module.exports = __webpack_public_path__ + "static/media/11.712b2823.jpg";